import Vue from 'vue'
import _ from 'lodash'

export const updateComponents = (state, payload) => {
  state.components = payload
}

// These three mutations are mostly for updating the state from firestore
export const addComponent = (state, newItem) => {
  Vue.set(state.components, newItem.id, newItem)
}

export const removeComponent = (state, idToRemove) => {
  Vue.delete(state.components, idToRemove)
}

export const modifyComponent = (state, componentToModify) => {
  if (_.isMatch(state.components[componentToModify.id], _.omit(componentToModify, ['updatedAt']))) {
    console.log('contents identical so not modified: ' + componentToModify.id)
    return
  }
  Vue.set(state.components, componentToModify.id, componentToModify)
}
